import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { WithdrawalContext } from "@state/context/payment/WithdrawalContext";

export default observer(function SelectedWithdrawalAmount() {
	const { currentFormData, paymentMethods } = useContext(WithdrawalContext);
	const selectedPaymentMethod = paymentMethods?.find(
		(item: { paymentMethodId: string }) =>
			item.paymentMethodId === currentFormData?.paymentMethodId
	);

	return (
		<>
			<label htmlFor="currentAmount" className="label">
				Selected amount
			</label>
			<div className="form__field--icon">
				<input
					type="number"
					id="currentAmount"
					className="form__field--icon__input input input--med"
					value={currentFormData?.amount}
					disabled
				/>
				<div className="form__field--icon__symbol">
					{selectedPaymentMethod?.currencyDisplayCode}
				</div>
			</div>
		</>
	);
});
